module.exports = __webpack_public_path__ + "static/media/people9.882eb5b9.jpeg";